module.exports = __webpack_public_path__ + "static/media/single_channel_partner.fca8675a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/single_channel_partner.svg
// module id = 450
// module chunks = 0